export default "__VITE_ASSET__BcjwG12e__"